import PipscLogo from '@nv/images/logos/pipsc-voter-portal/pipsc-logo'
import PipscLogoCollapsed from '@nv/images/logos/pipsc-voter-portal/pipsc-logo-collapsed'
import PipscLogoFr from '@nv/images/logos/pipsc-voter-portal/pipsc-logo-fr'

export const pipscTheme = {
  bgColor: 'var(--color-white)',
  textColor: 'var(--color-black)',
  logos: { en: PipscLogo, fr: PipscLogoFr },
  MobileLogo: PipscLogoCollapsed,
}
